/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-useless-constructor */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import LatestModalDesign from './LatestModalDesign';
import BlueCheckLottie from './BlueCheckLottie';

export default class SuccessModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <LatestModalDesign isOpen={this.props.isOpen} hideBackArrow hideFooter>
                <div className="mb-16"><BlueCheckLottie /></div>
                <div className="size-20-28 medium-font txt-center mb-12 contentPrimary">{this.props.title}</div>
                {this.props.subtitle ? <div className="size-12-20 txt-center clr-gray mb-36 contentPrimary">{this.props.subtitle}</div> : null}
                {this.props.customCTA ? this.props.customCTA : (
                    <div className='txt-center'>
                        <button type='button' className='btn md-cta-primary p-10-12-imp'
                            onClick={this.props.action}
                            style={{ width: "auto" }}
                        >{this.props.ctaText ? this.props.ctaText : 'Yay! Continue'}</button>
                    </div>
                )}
            </LatestModalDesign>
        );
    }
}
